<div class="h-100">
  <p class="text-center p-4">© {{ currentYear }} {{'FOOTER.FIRA_TEXT'|translate}}</p>
</div>
